<script>
export default {
  name: "NanAsync",

  props: {
    await: {
      type: Promise
    },
    delayed: Boolean
  },

  data: () => ({
    loading: false,
    results: null,
    error: null
  }),

  mounted() {
    if (this.delayed) return;
    this.triggerPromise();
  },

  methods: {
    async triggerPromise(promise) {
      promise = promise || this.await;

      this.loading = true;
      this.results = null;
      this.error = null;

      try {
        this.results = await promise;
        this.$emit("success", this.results);
      } catch (error) {
        this.error = error;
        this.$emit("error", error);
      } finally {
        this.loading = false;
      }
    }
  },

  render(create, test) {
    if (!this.$scopedSlots.default) {
      return create(false);
    }

    const scopedSlot = this.$scopedSlots.default({
      results: this.results,
      loading: this.loading,
      error: this.error,
      await: this.triggerPromise
    });

    if (scopedSlot.length > 1) {
      return create("div", [scopedSlot]);
    }

    return scopedSlot;
  }
};
</script>
